import type { CSSProperties } from "react"

import type { ModuleConfig } from "~/types/moduleConfig"

const brandColorMap: Record<string, string> = {
  transparent: "transparent",
  white: "#ffffff",
  lightGrey: "#efefef",
  darkGrey: "#6c6c6c",
  darkestGrey: "#3c3c3c",
  black: "#121212",
  pureBlack: "#000000",
  royalBlue: "#0027ff",
  deepBlue: "#001480",
  darkBlue: "#102542",
  teal: "#00ffe2",
  magenta: "#ff0d90",
}

export type ModuleConfigProps = {
  "data-spacing"?: string
  "data-rounded"?: string
  "data-typography"?: "dark"
  "data-full-height"?: "true"
  "data-frosted"?: "true"
  style?: CSSProperties
}

export function getModuleConfigProps(
  config: ModuleConfig | null | undefined,
): ModuleConfigProps {
  if (!config) return {}

  const props: ModuleConfigProps = {}

  if (config.spacing && config.spacing !== "none") {
    props["data-spacing"] = config.spacing
  }
  if (config.roundedCorners) {
    props["data-rounded"] = config.roundedCorners
  }
  if (config.darkTypography) {
    props["data-typography"] = "dark"
  }
  if (config.fullHeight) {
    props["data-full-height"] = "true"
  }
  if (config.frosted) {
    props["data-frosted"] = "true"
  }

  const start = config.backgroundGradient?.colorStart
  const end = config.backgroundGradient?.colorEnd

  const hasBg = start || end
  const fullyTransparent =
    hasBg && start === "transparent" && end === "transparent"

  if (hasBg && !fullyTransparent) {
    props.style = {
      "--module-bg-start": start
        ? (brandColorMap[start] ?? "transparent")
        : "transparent",
      "--module-bg-end": end
        ? (brandColorMap[end] ?? "transparent")
        : "transparent",
    } as CSSProperties
  }

  return props
}
